import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes)
  }, [_renderSlot(_ctx.$slots, "default")], 2);
}
import { computed } from 'vue';
import { classNames } from '../shared/utils.js';
import { colorClasses, colorProps } from '../shared/mixins.js';
export default {
  name: 'f7-swipeout-actions',
  render,
  props: {
    left: Boolean,
    right: Boolean,
    side: String,
    ...colorProps
  },
  setup(props) {
    const side = computed(() => {
      let sideComputed = props.side;
      if (!sideComputed) {
        if (props.left) sideComputed = 'left';
        if (props.right) sideComputed = 'right';
      }
      return sideComputed;
    });
    const classes = computed(() => classNames(`swipeout-actions-${side.value}`, colorClasses(props)));
    return {
      classes
    };
  }
};